import { Card } from "@/components/ui/card";
import { TimelineEvent } from "@/types/vehicleCard";
import { TimelineEventCard } from "./TimelineEvent";
import { TimelineHeader } from "./TimelineHeader";

interface MessageHistoryProps {
  carCardId: string;
  events?: TimelineEvent[];
  vehicleName?: string;
  regNumber?: string;
}

export const MessageHistory = ({
  carCardId,
  events = [],
  vehicleName = "",
  regNumber,
}: MessageHistoryProps) => {
  return (
    <div className="space-y-4 bg-card rounded-lg p-6 shadow-sm">
      <TimelineHeader />

      <div className="relative px-6">
        <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-muted" />
        <div className="space-y-6 py-4">
          {events.map((event) => (
            <TimelineEventCard
              key={event.id}
              event={event}
              vehicleName={vehicleName}
              regNumber={regNumber}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
